export default __webpack_public_path__ + "static/media/35_thumbnail.d806535e.JPG";